export const SET_LAWS_THEMES_FETCHING = 'SET_LAWS_THEMES_FETCHING';
export const SET_LAWS_THEMES_ERROR = 'SET_LAWS_THEMES_ERROR'
export const SET_LAWS_ALL_THEMES = 'SET_LAWS_ALL_THEMES';
export const CLEAN_LAWS_THEMES = 'CLEAN_LAWS_THEMES';
export const ABORT_THEMES_REQUEST = 'ABORT_THEMES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsThemes/actions.js